import React, { useEffect, useRef } from "react";
import "./Carbon.css";
import { useTranslation } from "react-i18next";

function Carbon() {
  const { t } = useTranslation();
    const fadeInRef = useRef(null); 
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show");
            } else {
              entry.target.classList.remove("show");
            }
          });
        },
        { threshold: 0.1 }
      );
  
      const fadeInElement = fadeInRef.current;
      if (fadeInElement) {
        observer.observe(fadeInElement);
      }
  
      return () => {
        if (fadeInElement) observer.unobserve(fadeInElement);
      };
    }, []);

  return (
    <div id="footprint-content" className="centraliz-content">
    <div className="text-ai-platfrom">
      <div className="text-header-centraliz">Carbon Footprint</div>
      <div className="sub-header-centraliz">{t("main_head_carbon")}</div>
    </div>
    <div className="carbon-footprint-image">
      <div className="centraliz-image-header">Carbon Footprint</div>
      <div className="centraliz-image-sub">
      <li>{t("main_sub_carbon_1")}</li>
      <li>{t("main_sub_carbon_2")}</li>
      <li>{t("main_sub_carbon_3")}</li>
      <li>{t("main_sub_carbon_4")}</li>
      </div>
    </div>
  </div>
  );
}

export default Carbon;
